export default [{
    text: 'Сельскохозяйственное использование',
    value: 'agricultural'
}, {
    text: 'ИЖС',
    value: 'individualHousingConstruction'
}, {
    text: 'МЖС',
    value: 'lowriseHousing'
}, {
    text: 'Высотная застройка',
    value: 'highriseBuildings'
}, {
    title: 'Общественное использование',
    text: 'Общественное использование объектов капитального строительства',
    value: 'publicUseOfCapitalConstruction'
}, {
    text: 'Деловое управление',
    value: 'businessManagement'
}, {
    text: 'Торговые центры',
    value: 'shoppingCenters'
}, {
    text: 'Гостиничное обслуживание',
    value: 'hotelAmenities'
}, {
    text: 'Обслуживание автотранспорта',
    value: 'serviceVehicles'
}, {
    text: 'Отдых (рекреация)',
    value: 'leisure'
}, {
    text: 'Промышленность',
    value: 'industry'
}, {
    text: 'Склады',
    value: 'warehouses'
}, {
    text: 'Общее пользование территории',
    value: 'commonUseArea'
}];
